import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { env } from '@/lib/env'
import { useCatalog } from '@/features/catalog/useCatalog'

export function Footer() {
  const { t } = useTranslation()
  const { data: catalog } = useCatalog()

  return (
    <footer className="mt-16 border-t border-border bg-surface">
      <div className="mx-auto flex max-w-content flex-wrap items-center gap-x-6 gap-y-2 px-4 py-6 text-meta text-text-muted">
        <Link to="/about" className="hover:text-text hover:underline">
          {t('footer.about')}
        </Link>
        <Link to="/about#rights" className="hover:text-text hover:underline">
          {t('footer.rights')}
        </Link>
        <a href={`mailto:${env.contactEmail}`} className="hover:text-text hover:underline">
          {t('footer.contact')}
        </a>
        <a
          href={`mailto:${env.contactEmail}?subject=${encodeURIComponent('ITPU Library — problem report')}`}
          className="hover:text-text hover:underline"
        >
          {t('footer.reportProblem')}
        </a>
        {catalog && (
          <span className="ml-auto tabular text-text-muted">
            {t('footer.catalogVersion', { version: catalog.version })}
          </span>
        )}
      </div>
    </footer>
  )
}
